import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { DateNavigationProps } from './types';

const DateNavigation: React.FC<DateNavigationProps> = ({
  onPrevious,
  onNext,
  isAtFirstDate,
  isAtLastDate,
  currentDates,
}) => {
  // Check if both visible dates are in the same month
  const isSameMonth =
    currentDates.length >= 2 &&
    currentDates[0].month === currentDates[1].month &&
    currentDates[0].year === currentDates[1].year;

  const getMonthName = (monthNum: string) => {
    const date = new Date(2023, parseInt(monthNum, 10) - 1, 1);
    return date.toLocaleString('en-US', { month: 'long' });
  };

  return (
    <div className="border-b px-1 bg-gray-100 dark:bg-gray-700 bg-opacity-70 dark:border-gray-700 rounded-t-lg">
      {/* Date labels aligned to the two half-columns with vertically centered chevrons */}
      {currentDates.length >= 2 && (
        <div className="relative py-1">
          <div className="flex">
            <div className="w-2/5" />
            {isSameMonth ? (
              <div className="w-3/5">
                <div className="text-center text-xs text-gray-500 dark:text-gray-400">
                  {getMonthName(currentDates[0].month)}
                </div>
                <div className="flex">
                  <div className="w-1/2 flex justify-center items-center">
                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      {currentDates[0].day}
                    </div>
                  </div>
                  <div className="w-1/2 flex justify-center items-center">
                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      {currentDates[1].day}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-3/5 flex">
                <div className="w-1/2 text-center">
                  <div className="text-xs text-gray-500 dark:text-gray-400">
                    {getMonthName(currentDates[0].month)}
                  </div>
                  <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                    {currentDates[0].day}
                  </div>
                </div>
                <div className="w-1/2 text-center">
                  <div className="text-xs text-gray-500 dark:text-gray-400">
                    {getMonthName(currentDates[1].month)}
                  </div>
                  <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                    {currentDates[1].day}
                  </div>
                </div>
              </div>
            )}
          </div>
          <button
            onClick={onPrevious}
            disabled={isAtFirstDate}
            className={`absolute left-1 top-1/2 -translate-y-1/2 p-0.5 rounded ${
              isAtFirstDate
                ? 'text-gray-300 dark:text-gray-600 cursor-not-allowed'
                : 'text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100'
            }`}
          >
            <ChevronLeft size={14} />
          </button>
          <button
            onClick={onNext}
            disabled={isAtLastDate}
            className={`absolute right-1 top-1/2 -translate-y-1/2 p-0.5 rounded ${
              isAtLastDate
                ? 'text-gray-300 dark:text-gray-600 cursor-not-allowed'
                : 'text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100'
            }`}
          >
            <ChevronRight size={14} />
          </button>
        </div>
      )}

      <div className="flex">
        <div className="w-2/5 flex items-center text-xs text-gray-600 dark:text-gray-300 py-0.5">
          Time (UTC)
        </div>
        <div className="w-3/5 flex">
          <div className="w-1/2 py-0.5 flex border-r dark:border-gray-700">
            {['00', '06', '12', '18'].map((time, i) => (
              <div
                key={i}
                className="w-[25%] flex justify-center items-center text-xs text-gray-500 dark:text-gray-400"
              >
                {time}
              </div>
            ))}
          </div>
          <div className="w-1/2 py-0.5 flex">
            {['00', '06', '12', '18'].map((time, i) => (
              <div
                key={i}
                className="w-[25%] flex justify-center items-center text-xs text-gray-500 dark:text-gray-400"
              >
                {time}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateNavigation;
